import { Quote, Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHead } from "./SectionHead";
import { testimonials } from "@/data/site";

export const Testimonials = () => (
  <section
    id="depoimentos"
    className="relative py-24 sm:py-28"
    data-testid="testimonials-section"
  >
    <div className="pointer-events-none absolute right-1/4 top-0 h-[320px] w-[520px] rounded-full bg-neon/8 blur-[140px]" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="Quem já usa, recomenda"
        title="Confiança de quem já assiste com a gente."
        right={
          <p className="max-w-xs font-mono text-xs uppercase leading-relaxed tracking-wider text-mist">
            Depoimentos coletados direto no WhatsApp
          </p>
        }
      />

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {testimonials.map((t, i) => (
          <Reveal key={t.id} delay={i * 0.08} className="h-full">
            <figure
              className="relative flex h-full flex-col rounded-3xl border border-white/10 bg-surface p-7 transition-[border-color,transform,box-shadow] hover:-translate-y-1 hover:border-neon/30 hover:shadow-[0_24px_60px_-24px_rgba(0,240,255,0.3)]"
              data-testid={`testimonial-card-${t.id}`}
            >
              <Quote className="h-7 w-7 text-neon/60" aria-hidden="true" />
              <div className="mt-4 flex gap-1" aria-hidden="true">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} className="h-4 w-4 fill-wa text-wa" />
                ))}
              </div>
              <blockquote className="mt-5 flex-1 text-base leading-relaxed text-white/90">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-mist">
                {t.label}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
